import React from 'react';
import useTilt from '../hooks/useTilt';

function ArticleItem({ image_src, title, link, tags }) {
  const tilt = useTilt({ max: 6, scale: 1.02 });

  return (
    <li className="articles__card-wrap">
      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        className="articles__card"
        ref={tilt.ref}
        onMouseMove={tilt.onMouseMove}
        onMouseLeave={tilt.onMouseLeave}
      >
        <div className="articles__card-image">
          <img src={image_src} alt={title} />
          <div className="articles__card-overlay" />
        </div>
        <div className="articles__card-body">
          <span className="articles__card-tag">{tags}</span>
          <h3 className="articles__card-title">{title}</h3>
          <span className="articles__card-cta">
            Read Article <i className="fa-solid fa-arrow-right" />
          </span>
        </div>
      </a>
    </li>
  );
}

export default ArticleItem;
